import * as React from 'react';
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import {AttributeTypeEnum} from "../../enums/AttributeTypeEnum";
import Axios from "../../../../config/Axios";
import Utils from "../../../../Utils";
import toastr from "toastr";
import AgSelectAllHeader from "../../common/AgSelectAllHeader";
import {helpHeaderTemplate} from "../../common/AgHeaderHelpToolTip";
import AgGridFooter from "../../common/AgGridFooter";
import AgGridUtils from "../../../../AgGridUtils";
import AgGridHelpToolTip from "../../common/AgGridFilterHelpTooltip";
import {approveTenantJoinRequests, denyTenantJoinRequests} from "../../../../actions/boCoreActions";

const AgGridReact = require('ag-grid-react').AgGridReact;

interface State {
    columnDefs: any;
    gridApi: any;
    columnApi: any;
    loading: boolean;
    selectedRows: number;
}

interface Props {
}

class UsersManagementGrid extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            columnDefs: [],
            gridApi: null,
            columnApi: null,
            loading: false,
            selectedRows: 0
        }
    }

    componentDidMount() {
        this.buildGrid();
        document.addEventListener('keydown', this.usersKeydownHandler);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.usersKeydownHandler);
    }

    usersKeydownHandler = (e) => {
        if (e.shiftKey && e.keyCode === 40) {
            e.preventDefault();
            Utils.$('.ag-floating-filter-input')[0].focus();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 65) {
            Utils.$('#approve-user-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 68) {
            Utils.$('#denial-btn').click();
        }
        if (e.keyCode === 9) {
            e.preventDefault();
            const element = document.activeElement;
            const id = element.id.split('-')[3];

            if (element.classList.contains("ag-floating-filter-input")) {
                if (Utils.$('.ag-floating-filter-input').length - 1 === Number.parseInt(id)) {
                    this.setGridFistCellOnFocus(e);
                } else {
                    const index = Number.parseInt(id) + 1;
                    Utils.$('.ag-floating-filter-input')[index].focus();
                }
            }
        }
    };

    setGridFistCellOnFocus = (event) => {
        if (event.keyCode === 9) {
            event.preventDefault();

            // scrolls to the first row
            this.state.gridApi.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.columnApi.getAllDisplayedColumns()[0];
            this.state.gridApi.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.gridApi.setFocusedCell(0, currentCol);
        }
    };

    buildGrid = () => {
        let columnDefs = [
            {
                id: "",
                headerName: "User ID",
                field: "userId",
                headerTooltip: "User ID",
                type: 'text',
                checkboxSelection: true,
                headerComponent: AgSelectAllHeader,
                dataType: AttributeTypeEnum.INT,
            },
            {
                field: 'username',
                headerName: "Username",
                tooltipField: 'Username',
                headerTooltip: "Username",
                type: 'text',
            },
            {
                field: 'email',
                headerName: "Email",
                tooltipField: 'email',
                headerTooltip: "email",
                type: 'text',
                cellRenderer: (params) => {
                    return params.value;
                }
            },
            {
                headerName: "Created", field: "createdTimestamp",
                dataType: AttributeTypeEnum.TIMESTAMP,
                headerTooltip: "Created"
            }
        ];


        this.setState({
            columnDefs: columnDefs
        }, () => this.addFilterIndex())
    }

    addFilterIndex = () => {
        Utils.$(".ag-floating-filter-input").each(function (index) {
            Utils.$(this).attr('id', 'userManagement-search-filter-' + index);
            Utils.$(this).attr('index', (index + 2));
        });
    };

    onGridReady = (params) => {
        if (!this.state.gridApi && !this.state.columnApi) {
            this.setState({
                gridApi: params.api,
                columnApi: params.columnApi
            }, () => {
                params.api.sizeColumnsToFit();
                Utils.$("#hide-nav-btn").on("click", function () {
                    setTimeout(() => {
                        params.api.sizeColumnsToFit();
                    }, 500);
                });
            })
        }
        params.api.setServerSideDatasource(this.ServerSideDatasource());
    }

    onGridReadyFirstRender = (params) => {
        this.setState({
            gridApi: params.api,
            columnApi: params.columnApi
        }, () => {
            params.api.sizeColumnsToFit();
            Utils.$("#hide-nav-btn").on("click", function () {
                setTimeout(() => {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
        })
    }

    ServerSideDatasource() {
        return {
            getRows: (params: any) => {
                const limit = params.request.endRow - params.request.startRow;
                const page = (params.request.endRow / limit) - 1;
                const sort = AgGridUtils.generateSortData(params.request.sortModel);
                const filter = AgGridUtils.generateFilterData(params);

                if (filter.hasOwnProperty('username')) {
                    filter['name'] = filter.username
                    delete filter.username
                }

                Axios.instanceV2.post(`tenant/request/all?page=${page}&limit=${limit}`, {
                    filter: JSON.stringify(filter),
                    sort: JSON.stringify(sort)
                })
                    .then((response: any) => {
                        const gridData = response.data.data.map(item => {
                            return {
                                id: item.id,
                                userId: item.userId,
                                email: item.email,
                                username: item.username,
                                createdTimestamp: Utils.moment(item.createdTimestamp, Utils.moment.ISO_8601).isValid() ? Utils.utcToLocalDate(item.createdTimestamp) : item.createdTimestamp
                            }
                        });

                        if (gridData.length === 0) {
                            this.state.gridApi.showNoRowsOverlay()
                        }

                        try {
                            const lastRow = gridData.length < limit ? params.request.startRow + gridData.length : -1;
                            params.successCallback(gridData, lastRow);
                            this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.update(response.data.totalElements,
                                (limit * (page + 1)) > response.data.totalElements ?
                                    response.data.totalElements : (limit * (page + 1)),
                                params.parentNode.gridApi.getSelectedRows().length);
                            if (this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.isSelected()) {
                                this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.selectAll();
                            }
                            this.state.gridApi.sizeColumnsToFit();
                            this.forceUpdate();
                        } catch (e) {
                            console.error(e);
                        }

                    })
                    .catch((e) => {
                        AgGridUtils.serverSideErrorHandler(e)
                        params.failCallback();
                    })
            }
        }
    }

    approveSelectedUsers = () => {
        const selectedRows = this.state.gridApi.getSelectedRows();
        if (selectedRows.length >= 1) {
            Utils.blurTheActiveElements();
            approveTenantJoinRequests(selectedRows.map(user => user.id))
                .then(() => {
                    this.refreshGrid();
                })
        } else {
            toastr.warning("Please select at least one user");
        }
    }

    denialSelectedUsers = () => {
        const selectedRows = this.state.gridApi.getSelectedRows();
        if (selectedRows.length >= 1) {
            Utils.blurTheActiveElements();
            Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                theme: 'dark',
                typeAnimated: false,
                content: `You are about to denial ${selectedRows.length} ${selectedRows.length > 1 ? 'users' : 'user'}, are you sure?`,
                type: 'red',
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            denyTenantJoinRequests(selectedRows.map(user => user.id))
                                .then(() => {
                                    this.refreshGrid();
                                })
                        }
                    },
                    cancel: () => {
                    }
                }
            });
        } else {
            toastr.warning("Please select at least one user");
        }
    }

    refreshGrid = () => {
        this.state.gridApi.onFilterChanged();
        this.state.gridApi.deselectAll();
    }

    onSelectionUserChanged = () => {
        this.setState({
            selectedRows: this.state.gridApi ? this.state.gridApi.getSelectedRows().length : 0
        })
    }

    render() {
        return (
            <div style={{height: 'calc(100% - 70px)'}}>
                <header style={{height: 50, display: "flex"}} className="bo-core-header top-header">
                    <div style={{
                        float: "left",
                        paddingLeft: 4,
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <span className="header-title">User Management</span>
                        <div className="control-buttons">
                            <button onClick={this.approveSelectedUsers} style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design"
                                    id={'approve-user-btn'} title={'CTRL + ALT + A'}>
                                <i className="fas fa-user-check"/> <strong style={{fontSize: '13px'}}
                                                                           className={'shortcut-btn-letters'}>A</strong>pprove
                            </button>
                            <button onClick={this.denialSelectedUsers} style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design"
                                    id={'denial-btn'} title={'CTRL + ALT + D'}>
                                <i className="fas fa-user-times"/> <strong style={{fontSize: '13px'}}
                                                                           className={'shortcut-btn-letters'}>D</strong>eny
                            </button>
                        </div>
                    </div>
                </header>
                <div style={{height: '100%', padding: 10}}>
                    <div style={{width: "100%", height: "99%"}} className={"ag-theme-balham-dark ag-grids"}>
                        <AgGridReact
                            onGridReady={this.onGridReady}
                            onFirstDataRendered={this.onGridReadyFirstRender}
                            columnDefs={this.state.columnDefs}
                            defaultColDef={{
                                minWidth: 150,
                                flex: 1,
                                filter: "agTextColumnFilter",
                                floatingFilter: true,
                                sortable: true,
                                autoHeight: true,
                                resizable: true,
                                tooltipComponent: AgGridHelpToolTip,
                                headerComponentParams: {
                                    template: helpHeaderTemplate
                                },
                                filterParams: {
                                    filterOptions: ['contains'],
                                    applyButton: true,
                                    clearButton: true,
                                    suppressAndOrCondition: true
                                },
                                floatingFilterComponentParams: {suppressFilterButton: true},
                            }}
                            gridOptions={{
                                suppressDragLeaveHidesColumns: true,
                                floatingFilter: true,
                                rowSelection: "multiple",
                                rowModelType: 'serverSide',
                                blockLoadDebounceMillis: 300,
                                onSelectionChanged: this.onSelectionUserChanged,
                            }}>
                        </AgGridReact>
                        <AgGridFooter
                            totalCount={this.state.gridApi ? this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().totalItemsCount : 0}
                            loadedCount={this.state.gridApi ? this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().loadedItemsCount : 0}
                            selectedCount={this.state.gridApi ? this.state.selectedRows : 0}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default UsersManagementGrid;



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/UsersManagementGrid/UsersManagementGrid.tsx